import { SwiperOptions } from "swiper";

export const configCarrossel: SwiperOptions["breakpoints"] = {
  320: {
    slidesPerView: 1,
    spaceBetween: 4,
    slidesPerGroup: 1,
  },

  480: {
    slidesPerView: 2,
    spaceBetween: 4,
  },

  1024: {
    slidesPerView: 3,
    spaceBetween: 3,
  },
};
